// export const API_PORT = '5000'
// // export const API_URL = `http://localhost:${API_PORT}`
// export const API_URL = 'https://naturalmedicineportal.com/api'
export const DOMAIN_TITLE = 'naturalmedicineportal.com'
export const ASSETS_PATH = process.env.NODE_ENV === 'production' ? '/assets/app/' : '/'
export const POST_ASSETS_PATH = process.env.NODE_ENV === 'production' ? '/images/posts/' : 'http://naturalmedicineportal.test/images/posts/'
